module.exports = __webpack_public_path__ + "static/media/diamond-icon.58ecdb74.svg";